import validator from 'validator';

class FormValidator {
  constructor(validations) {
    this.validations = validations;
  }

  validate(state) {
    const validation = this.valid();

    this.validations.forEach((rule) => {
      if (!validation[rule.field].isInvalid) {
        const fieldValue = state[rule.field].toString();
        const args = rule.args || [];

        rule.method.forEach((method) => {
          const action = validator[method];// validator[method] ? validator[method] : custValidations[method];
          const hasError = action(fieldValue, ...args, state);
          if (fieldValue == "confirmPassword" && args == "password") {
            if (args !== validation[rule.field]) {
              validation[rule.field] = { isInvalid: true, message: typeof hasError === 'boolean' ? rule.message : hasError };
              validation.isValid = false;
            }
          } 
          if (hasError !== rule.validWhen) {
            validation[rule.field] = { isInvalid: true, message: typeof hasError === 'boolean' ? rule.message : hasError };
            validation.isValid = false;
          }
        });
      }
    });
    return validation;
  }

  valid() {
    const validation = {};

    this.validations.forEach((rule) => {
      validation[rule.field] = { isInvalid: false, message: rule.message || '' };
    });

    return { isValid: true, ...validation };
  }
}

export default FormValidator;
